<template>
    <v-app-bar
        :color="esMovil ? 'primary' : 'white'"
        :dark="esMovil ? true : false"
        clipped-left
        app
        dense
        elevation="0"
        :height="esMovil ? 55 : 100"
    >
        <v-app-bar-nav-icon @click="activarDrawer" v-if="esMovil"></v-app-bar-nav-icon>
        <router-link :to="{ name: 'inicio' }">
            <v-img
                src="/Agenda-Urbana-Vinaros-Logo.png"
                height="70"
                max-width="197"
                class="d-none d-md-block ml-4"
            >
            </v-img>
        </router-link>

        <v-app-bar-title v-if="esMovil">
            {{ $t("layout.texto.titulo-movil") }}
        </v-app-bar-title>

        <v-tabs v-if="!esMovil" optional right hide-slider>
            <v-spacer></v-spacer>
            <v-tab
                v-for="(enlace, index) in enlacesDesktop"
                :key="index"
                :to="enlace.link"
                :exact="index != 1"
                class="font-weight-bold"
                style="color: #1b6cff"
                :active-class="index == 1 ? 'tab-activo' : ''"
                :exact-active-class="index != 1 ? 'tab-activo' : ''"
            >
                {{ enlace.texto }}
            </v-tab>
            <v-tab class="px-0 llenar-contenido">
                <ModalBusqueda>
                    <div class="mx-4" style="color: #1b6cff">Buscar</div>
                </ModalBusqueda>
            </v-tab>
            <v-tab class="px-0 llenar-contenido">
                <v-btn
                    v-if="!esMovil"
                    class="ml-4 mr-4 text--white"
                    color="primary"
                    depressed
                    style="letter-spacing: 0; color: white"
                    href="https://agendaurbana.vinaros.es"
                    target="_blank"
                >
                    {{ $t("layout.enlaces.agenda-urbana") }}
                </v-btn>
            </v-tab>
            <v-tab class="px-0 llenar-contenido">
                <SelectorIdioma></SelectorIdioma>
            </v-tab>
        </v-tabs>

    </v-app-bar>
</template>

<script>
import SelectorIdioma from "@components/SelectorIdioma";
import ModalBusqueda from "../components/ModalBusqueda.vue";

export default {
    name: "HeaderSuperior",
    props: {
        esMovil: {
            type: Boolean,
            required: true,
            default: false,
        },
        enlacesDesktop: {
            type: Array,
            default: [],
        },
    },
    components: {
        SelectorIdioma,
        ModalBusqueda,
    },
    methods: {
        activarDrawer: function () {
            this.$emit("activarDrawer");
        },
    },
};
</script>

<style scoped>
.v-tab.texto-mantenimiento {
    color: #eb5c63 !important;
    opacity: 1;
}

.tab-activo {
    border-bottom: 2px solid #263676;
}
</style>

<style>
.llenar-contenido div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
